<template>
  <div :class="['loading-bars-container', `loading-bars-container--${size}`]">
    <div :class="['loading-bars', `loading-bars--${size}`]">
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
    <span v-if="showText" :class="['loading-text', `loading-text--${size}`]">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "LoadingBars",
  props: {
    size: {
      type: String,
      default: "lg",
      validator: (value) => ["xs", "sm", "md", "lg"].includes(value),
    },
    text: {
      type: String,
      default: "Loading...",
    },
    showText: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.loading-bars-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
}

.loading-bars-container--xs {
  gap: 8px;
}

.loading-bars-container--sm {
  gap: 12px;
}

.loading-bars-container--md {
  gap: 14px;
}

.loading-bars-container--lg {
  gap: 16px;
}

.loading-bars {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.loading-bars--xs {
  height: 12px;
  gap: 2px;
}

.loading-bars--xs .bar {
  width: 2px;
  border-radius: 2px;
}

.loading-bars--sm {
  height: 20px;
  gap: 3px;
}

.loading-bars--sm .bar {
  width: 3px;
  border-radius: 3px;
}

.loading-bars--md {
  height: 24px;
  gap: 4px;
}

.loading-bars--md .bar {
  width: 4px;
  border-radius: 4px;
}

.loading-bars--lg {
  height: 32px;
  gap: 5px;
}

.loading-bars--lg .bar {
  width: 5px;
  border-radius: 5px;
}

.loading-bars .bar {
  height: 100%;
  background: #3e3efe;
  transform: scaleY(0.4);
  opacity: 0.6;
  transform-origin: center;
  will-change: transform, opacity;
  animation: pulse 1.2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

.loading-bars .bar:nth-child(1) {
  animation-delay: 0s;
}

.loading-bars .bar:nth-child(2) {
  animation-delay: 0.15s;
}

.loading-bars .bar:nth-child(3) {
  animation-delay: 0.3s;
}

.loading-bars .bar:nth-child(4) {
  animation-delay: 0.45s;
}

@keyframes pulse {
  0%,
  100% {
    transform: scaleY(0.4);
    opacity: 0.6;
  }
  50% {
    transform: scaleY(1);
    opacity: 1;
  }
}

.loading-text {
  color: #6b7280;
  font-weight: 500;
}

.loading-text--sm {
  font-size: 0.7rem;
}

.loading-text--md {
  font-size: 0.8rem;
}

.loading-text--lg {
  font-size: 0.9rem;
}
</style>
